module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921135651_T.9edf6f85.jpg";